var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _circle3, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path30, _path31, _path32, _path33, _circle4, _path34, _rect23, _circle5, _path35, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path36, _path37, _rect24, _path38, _path39, _path40, _path41, _path42, _rect25, _rect26, _rect27, _polygon9, _path43, _path44, _path45, _path46, _path47, _rect28, _path48, _path49, _path50, _path51, _path52, _path53, _rect29, _rect30, _rect31, _rect32, _path54, _path55, _rect33, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _rect34, _path66, _path67, _path68, _rect35, _path69, _path70, _rect36, _path71, _path72, _rect37, _rect38, _path73, _path74, _path75, _path76, _path77, _path78, _polygon10, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _polygon11, _path87, _rect39, _rect40, _rect41, _path88, _rect42, _rect43, _rect44, _path89, _rect45, _rect46, _rect47, _path90, _rect48, _rect49, _rect50, _path91, _rect51, _rect52, _rect53, _path92, _rect54, _rect55, _rect56, _path93, _rect57, _rect58, _rect59, _path94, _rect60, _rect61, _rect62, _path95, _rect63, _rect64, _rect65, _path96, _rect66, _rect67, _rect68, _path97, _rect69, _rect70, _rect71, _path98, _rect72, _rect73, _rect74, _path99, _rect75, _rect76, _rect77, _path100, _rect78, _rect79, _rect80, _path101, _rect81, _rect82, _rect83, _path102, _rect84, _rect85, _rect86, _path103, _rect87, _rect88, _rect89, _path104, _rect90, _rect91, _rect92, _path105, _circle6, _path106, _path107, _path108, _rect93;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 274.41 153.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".landing-svg-1,.landing-svg-2{fill:#d7edff;}.landing-svg-1{opacity:0.35;}.landing-svg-3{fill:#ffa8a4;}.landing-svg-4{fill:#fff;}.landing-svg-5{fill:#d8d65b;}.landing-svg-6{fill:#a4c2ff;}.landing-svg-7{fill:#404066;}.landing-svg-8{fill:#343456;}.landing-svg-9{fill:#00739b;}.landing-svg-10{fill:#0397c7;}.landing-svg-11{fill:#f9e343;}.landing-svg-12{fill:#ee5f3e;}.landing-svg-13{fill:#5ab784;}.landing-svg-14{fill:#dce8ea;}.landing-svg-15{fill:#a1dba5;}.landing-svg-16{fill:#6f9be2;}.landing-svg-17{fill:#e4917e;}.landing-svg-18{fill:#543026;}.landing-svg-19{fill:#44251d;}.landing-svg-20{fill:#5e342a;}.landing-svg-21{fill:#753e34;}.landing-svg-22{fill:#1c1c1e;}.landing-svg-23{fill:#313135;}.landing-svg-24{fill:#ca6b61;}.landing-svg-25{fill:#231a1c;}.landing-svg-26{fill:#204042;}.landing-svg-27{fill:#294a4e;}.landing-svg-28{fill:#1a2e30;}.landing-svg-29{fill:url(#linear-gradient);}.landing-svg-30{fill:url(#linear-gradient-2);}.landing-svg-31{fill:#ffd371;}.landing-svg-32{fill:#e4ecef;}.landing-svg-33{fill:#963838;}.landing-svg-34{fill:#f2ba3d;}.landing-svg-35{fill:#e89c23;}.landing-svg-36{fill:#f8d745;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 25.59,
    y1: 129.56,
    x2: 40.87,
    y2: 129.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 81.92, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fbad3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f9a432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f79620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f7941e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 26,
    y1: 127.11,
    x2: 27.48,
    y2: 127.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-1",
    d: "M26.26,60.49C32.19,49.85,43,42,54.86,36.79c25-11,54.05-11.14,81.86-10.24,15.31.49,30.61,1.22,45.9,2,14.23.68,28.73,1.41,42,6,17.59,6.09,31.81,18.64,41.86,33.09a103.49,103.49,0,0,1,17.74,73.79c-.81,5.46-2.27,11.21-6.63,15-5.18,4.53-13,5.19-20.21,5.6l-71.13,4c-9.42.53-19.22,1-27.95-2.23-10.89-4-18.37-13.2-28.3-18.92-27.49-15.85-65.45-3.75-92.29-19.31C17.19,113.7,16.53,77.91,26.26,60.49Z",
    transform: "translate(-11.57 -26.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-2",
    d: "M197.51,45.21c-9.06-4.33-18.95-7.06-28.94-9.09a226.06,226.06,0,0,0-35.42-4.31c-32.4-1.39-66.65,4.94-91.07,24.31C32.2,64,24.16,73.82,19.52,85c-4.12,9.88-5.51,20.5-6.85,31-1.33,10.31-2.49,21.43,3.14,30.47,9.3,14.92,31.67,17,50.57,17.24l58.6.86c14.55.21,29.12.43,43.65-.26,14.32-.68,28.58-2.23,42.82-3.78L252.6,156c38-4.14,36.38-36,13.74-57.76-7.93-7.62-18.38-13-26.95-20C225.42,66.83,214.52,53.32,197.51,45.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-3",
    d: "M87.83,72.1c4.29,16.41-.42,30.32-9.72,32.65s-20-7.72-24-24.22a38,38,0,0,1,9-35.37A38.44,38.44,0,0,1,87.83,72.1Z",
    transform: "translate(-11.57 -26.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M77.35,103.61a.36.36,0,0,1-.43-.25l-13.78-55a.35.35,0,0,1,.25-.42.36.36,0,0,1,.43.25l13.78,55A.36.36,0,0,1,77.35,103.61Z",
    transform: "translate(-11.57 -26.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M69.34,72.14a.34.34,0,0,1-.22,0l-11-4.69a.35.35,0,1,1,.28-.64l11,4.68a.36.36,0,0,1,.18.47A.35.35,0,0,1,69.34,72.14Z",
    transform: "translate(-11.57 -26.21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M72.68,85a.36.36,0,0,1-.38-.55L83.5,68.8a.35.35,0,0,1,.49-.08.34.34,0,0,1,.08.49L72.88,84.82A.39.39,0,0,1,72.68,85Z",
    transform: "translate(-11.57 -26.21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M73.06,87.7a.34.34,0,0,1-.2,0L57.64,82.63a.35.35,0,0,1-.23-.45.37.37,0,0,1,.45-.22L73.09,87a.35.35,0,0,1,.22.44A.34.34,0,0,1,73.06,87.7Z",
    transform: "translate(-11.57 -26.21)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M66.75,61.31a.35.35,0,0,1-.38-.52l4.91-8.36a.35.35,0,1,1,.61.35L67,61.14A.34.34,0,0,1,66.75,61.31Z",
    transform: "translate(-11.57 -26.21)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-5",
    d: "M65.74,87c12.11,11.88,15.2,26.23,8.42,33s-21.13,3.64-33-8.49a38,38,0,0,1-10.41-35A38.45,38.45,0,0,1,65.74,87Z",
    transform: "translate(-11.57 -26.21)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M72.92,119.45a.37.37,0,0,1-.5,0L32.34,79.28a.34.34,0,0,1,0-.49.35.35,0,0,1,.5,0L72.92,119A.37.37,0,0,1,72.92,119.45Z",
    transform: "translate(-11.57 -26.21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M45.49,92.13a.54.54,0,0,1-.2.1l-11.82,1.6a.36.36,0,0,1-.4-.3.36.36,0,0,1,.31-.4l11.81-1.6a.36.36,0,0,1,.4.3A.41.41,0,0,1,45.49,92.13Z",
    transform: "translate(-11.57 -26.21)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M50.08,96.86a.34.34,0,0,1-.2.09L35,99.05a.35.35,0,1,1-.1-.69l14.92-2.1a.35.35,0,0,1,.4.3A.34.34,0,0,1,50.08,96.86Z",
    transform: "translate(-11.57 -26.21)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M53.68,100.05a.35.35,0,0,1-.59-.28L54.53,82.1a.36.36,0,0,1,.38-.32.33.33,0,0,1,.32.37L53.79,99.83A.36.36,0,0,1,53.68,100.05Z",
    transform: "translate(-11.57 -26.21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M65.46,111.81a.29.29,0,0,1-.28.1.33.33,0,0,1-.31-.38L67,92.21a.35.35,0,0,1,.39-.31.36.36,0,0,1,.31.39L65.57,111.6A.31.31,0,0,1,65.46,111.81Z",
    transform: "translate(-11.57 -26.21)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M61.07,108a.39.39,0,0,1-.17.09l-15.67,3.47a.35.35,0,1,1-.15-.69l15.67-3.47a.35.35,0,0,1,.42.27A.34.34,0,0,1,61.07,108Z",
    transform: "translate(-11.57 -26.21)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M42.11,88.58a.35.35,0,0,1-.6-.25l-.07-9.7a.35.35,0,0,1,.7,0l.08,9.7A.34.34,0,0,1,42.11,88.58Z",
    transform: "translate(-11.57 -26.21)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-6",
    d: "M184.38,91c-12,12-26.38,14.94-33.08,8.09s-3.43-21.16,8.82-32.9a38,38,0,0,1,35.1-10.05A38.43,38.43,0,0,1,184.38,91Z",
    transform: "translate(-11.57 -26.21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M151.89,97.84a.36.36,0,0,1,0-.5l40.57-39.66a.34.34,0,0,1,.49,0,.35.35,0,0,1,0,.5L152.39,97.85A.36.36,0,0,1,151.89,97.84Z",
    transform: "translate(-11.57 -26.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M175.64,74.34a.38.38,0,0,1-.1-.2l-1.95-15a.36.36,0,0,1,.31-.39.34.34,0,0,1,.39.3l2,14.95a.36.36,0,0,1-.31.39A.37.37,0,0,1,175.64,74.34Z",
    transform: "translate(-11.57 -26.21)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M171.48,78.81a.38.38,0,0,1-.09-.28.35.35,0,0,1,.38-.32l17.66,1.63a.36.36,0,0,1,.32.38.35.35,0,0,1-.39.32L171.7,78.91A.37.37,0,0,1,171.48,78.81Z",
    transform: "translate(-11.57 -26.21)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M166.31,84.08a.35.35,0,0,1-.1-.29.36.36,0,0,1,.39-.31l19.29,2.29a.36.36,0,0,1,.31.39.36.36,0,0,1-.39.31l-19.29-2.29A.35.35,0,0,1,166.31,84.08Z",
    transform: "translate(-11.57 -26.21)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M161.28,88.41a.39.39,0,0,1-.09-.17l-3.3-15.7a.35.35,0,0,1,.27-.42.34.34,0,0,1,.41.27l3.31,15.71a.34.34,0,0,1-.27.41A.34.34,0,0,1,161.28,88.41Z",
    transform: "translate(-11.57 -26.21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M183.07,67.35a.35.35,0,0,1,.26-.59l9.69,0a.36.36,0,0,1,.36.35.34.34,0,0,1-.36.35l-9.7,0A.36.36,0,0,1,183.07,67.35Z",
    transform: "translate(-11.57 -26.21)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-6",
    d: "M211.48,105.06h-1.73a12.81,12.81,0,0,0-2.36-5.69l1.23-1.23a.45.45,0,0,0,0-.64l-2.06-2.06a.46.46,0,0,0-.65,0l-1.22,1.23A12.68,12.68,0,0,0,199,94.31V92.57a.47.47,0,0,0-.46-.46h-2.91a.47.47,0,0,0-.46.46v1.74a12.58,12.58,0,0,0-5.69,2.36l-1.23-1.23a.45.45,0,0,0-.64,0l-2.06,2.06a.45.45,0,0,0,0,.64l1.22,1.23a12.68,12.68,0,0,0-2.35,5.69h-1.74a.47.47,0,0,0-.46.46v2.91a.47.47,0,0,0,.46.46h1.74a12.77,12.77,0,0,0,2.35,5.69l-1.22,1.22a.46.46,0,0,0,0,.65l2.06,2.06a.45.45,0,0,0,.64,0l1.23-1.23a12.81,12.81,0,0,0,5.69,2.36v1.74a.46.46,0,0,0,.46.45h2.91a.46.46,0,0,0,.46-.45v-1.74a12.9,12.9,0,0,0,5.69-2.36l1.22,1.23a.46.46,0,0,0,.65,0l2.06-2.06a.46.46,0,0,0,0-.65l-1.23-1.22a12.9,12.9,0,0,0,2.36-5.69h1.73a.46.46,0,0,0,.46-.46v-2.91A.46.46,0,0,0,211.48,105.06Zm-14.4,7.74a5.83,5.83,0,1,1,5.83-5.83A5.83,5.83,0,0,1,197.08,112.8Z",
    transform: "translate(-11.57 -26.21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M197.08,115.58a8.61,8.61,0,1,1,8.61-8.61A8.61,8.61,0,0,1,197.08,115.58Zm0-16.73a8.13,8.13,0,1,0,8.13,8.12A8.13,8.13,0,0,0,197.08,98.85Z",
    transform: "translate(-11.57 -26.21)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-6",
    d: "M223.7,80.52h-1.21a8.91,8.91,0,0,0-1.65-4l.86-.86a.31.31,0,0,0,0-.45l-1.44-1.44a.33.33,0,0,0-.45,0l-.86.86A9.06,9.06,0,0,0,215,73V71.79a.33.33,0,0,0-.32-.32h-2a.33.33,0,0,0-.32.32V73a9.06,9.06,0,0,0-4,1.65l-.86-.86a.33.33,0,0,0-.45,0l-1.44,1.44a.31.31,0,0,0,0,.45l.86.86a8.91,8.91,0,0,0-1.65,4h-1.21a.32.32,0,0,0-.32.32v2a.32.32,0,0,0,.32.32h1.21a8.87,8.87,0,0,0,1.65,4l-.86.86a.31.31,0,0,0,0,.45L207,89.92a.33.33,0,0,0,.45,0l.86-.86a8.83,8.83,0,0,0,4,1.65v1.21a.32.32,0,0,0,.32.32h2a.32.32,0,0,0,.32-.32V90.71a8.83,8.83,0,0,0,4-1.65l.86.86a.33.33,0,0,0,.45,0l1.44-1.44a.31.31,0,0,0,0-.45l-.86-.86a8.87,8.87,0,0,0,1.65-4h1.21a.32.32,0,0,0,.32-.32v-2A.32.32,0,0,0,223.7,80.52Zm-10.06,5.41a4.08,4.08,0,1,1,4.08-4.07A4.08,4.08,0,0,1,213.64,85.93Z",
    transform: "translate(-11.57 -26.21)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M213.64,87.87a6,6,0,1,1,6-6A6,6,0,0,1,213.64,87.87Zm0-11.69a5.68,5.68,0,1,0,5.68,5.68A5.68,5.68,0,0,0,213.64,76.18Z",
    transform: "translate(-11.57 -26.21)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-6",
    d: "M240.1,104h-1.41a10.28,10.28,0,0,0-1.91-4.61l1-1a.36.36,0,0,0,0-.52l-1.67-1.67a.36.36,0,0,0-.52,0l-1,1A10.39,10.39,0,0,0,230,95.25V93.84a.38.38,0,0,0-.37-.37h-2.36a.37.37,0,0,0-.37.37v1.41a10.43,10.43,0,0,0-4.62,1.91l-1-1a.36.36,0,0,0-.52,0l-1.67,1.67a.37.37,0,0,0,0,.52l1,1a10.29,10.29,0,0,0-1.92,4.61h-1.4a.37.37,0,0,0-.37.37v2.36a.36.36,0,0,0,.37.37h1.4a10.33,10.33,0,0,0,1.92,4.62l-1,1a.37.37,0,0,0,0,.52l1.67,1.67a.37.37,0,0,0,.52,0l1-1a10.33,10.33,0,0,0,4.62,1.92v1.4a.36.36,0,0,0,.37.37h2.36a.37.37,0,0,0,.37-.37v-1.4a10.29,10.29,0,0,0,4.61-1.92l1,1a.37.37,0,0,0,.52,0l1.67-1.67a.36.36,0,0,0,0-.52l-1-1a10.31,10.31,0,0,0,1.91-4.62h1.41a.37.37,0,0,0,.37-.37v-2.36A.38.38,0,0,0,240.1,104Zm-11.68,6.28a4.73,4.73,0,1,1,4.73-4.73A4.72,4.72,0,0,1,228.42,110.25Z",
    transform: "translate(-11.57 -26.21)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M228.42,112.5a7,7,0,1,1,7-7A7,7,0,0,1,228.42,112.5Zm0-13.57a6.6,6.6,0,1,0,6.59,6.59A6.6,6.6,0,0,0,228.42,98.93Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-7",
    x: 104.38,
    y: 129.82,
    width: 9.88,
    height: 20.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-8",
    x: 104.38,
    y: 129.23,
    width: 9.88,
    height: 6.27
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-8",
    x: 104.38,
    y: 144.38,
    width: 9.88,
    height: 6.27
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-7",
    x: 55.51,
    y: 62.28,
    width: 107.63,
    height: 68.84
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-6",
    x: 59.11,
    y: 65.84,
    width: 100.43,
    height: 61.73
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-8",
    x: 90.47,
    y: 148.14,
    width: 37.71,
    height: 5.13
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-4",
    x: 63.14,
    y: 68.45,
    width: 92.47,
    height: 56.56
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-9",
    x: 63.14,
    y: 68.19,
    width: 92.47,
    height: 5.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-10",
    x: 66.1,
    y: 69.21,
    width: 27.26,
    height: 3.31
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-11",
    cx: 143.41,
    cy: 70.98,
    r: 1.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-12",
    cx: 137.98,
    cy: 70.98,
    r: 1.24
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-13",
    cx: 148.84,
    cy: 70.98,
    r: 1.24
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 67.08,
    y: 77.69,
    width: 45.59,
    height: 41.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 77.69,
    width: 30.03,
    height: 1.37
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 82.19,
    width: 30.03,
    height: 1.37
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 86.69,
    width: 30.03,
    height: 1.37
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 91.18,
    width: 30.03,
    height: 1.37
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 95.68,
    width: 30.03,
    height: 1.37
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 100.18,
    width: 30.03,
    height: 1.37
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 104.67,
    width: 30.03,
    height: 1.37
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 109.17,
    width: 30.03,
    height: 1.37
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 113.67,
    width: 30.03,
    height: 1.37
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-14",
    x: 119.94,
    y: 118.17,
    width: 30.03,
    height: 1.37
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-13",
    x: 134.75,
    y: 97.09,
    width: 103.44,
    height: 56.18
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-15",
    x: 137.09,
    y: 100.26,
    width: 98.76,
    height: 50.04
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-13",
    d: "M162,125.82s.41,12.13-13.56,13.56V125.82Z",
    transform: "translate(-11.57 -26.21)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-13",
    d: "M234.12,125.82s-.41,12.13,13.56,13.56V125.82Z",
    transform: "translate(-11.57 -26.21)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-13",
    d: "M162,177s.41-12.13-13.56-13.57V177Z",
    transform: "translate(-11.57 -26.21)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-13",
    d: "M234.12,177s-.41-12.13,13.56-13.57V177Z",
    transform: "translate(-11.57 -26.21)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-4",
    cx: 186.47,
    cy: 125.18,
    r: 18.87
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-15",
    d: "M198.12,163.21h-.44a7.57,7.57,0,0,1-6.8-4.11,1.23,1.23,0,1,1,2.18-1.14,5.16,5.16,0,0,0,4.75,2.8,6.07,6.07,0,0,0,3.92-1.19,3.8,3.8,0,0,0,1.43-3.62,3.76,3.76,0,0,0-2.5-2.54,13,13,0,0,0-2.46-.53c-.63-.09-1.28-.19-1.95-.35-1.22-.3-4.19-1.23-5.28-3.47a6.6,6.6,0,0,1,1.34-7.26,8,8,0,0,1,7.26-2.07,6.78,6.78,0,0,1,5.2,4.19,1.23,1.23,0,0,1-2.3.87,4.39,4.39,0,0,0-3.38-2.65,5.59,5.59,0,0,0-5,1.35,4.18,4.18,0,0,0-.91,4.49c.52,1.07,2.29,1.83,3.65,2.16.56.13,1.13.22,1.74.31a14.93,14.93,0,0,1,2.91.64,6.12,6.12,0,0,1,4.09,4.33,6.24,6.24,0,0,1-2.37,6.12A8.57,8.57,0,0,1,198.12,163.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-15",
    x: 185.64,
    y: 109.94,
    width: 1.66,
    height: 30.48,
    rx: 0.71
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-13",
    cx: 153.03,
    cy: 125.18,
    r: 5.16
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-13",
    d: "M236.65,151.38a5.17,5.17,0,1,1-5.17-5.16A5.16,5.16,0,0,1,236.65,151.38Z",
    transform: "translate(-11.57 -26.21)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-16",
    points: "44.73 57.28 48.28 57.28 39.38 41.6 35.83 41.6 44.73 57.28"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-6",
    points: "48.26 57.28 44.71 57.28 58.73 32.58 62.28 32.58 48.26 57.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-6",
    points: "76.3 57.28 72.75 57.28 89.86 27.15 93.41 27.15 76.3 57.28"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-16",
    points: "106.96 57.29 110.51 57.29 93.4 27.16 89.85 27.16 106.96 57.29"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-6",
    points: "110.52 57.28 106.97 57.28 127.81 20.64 131.36 20.64 110.52 57.28"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-16",
    points: "72.75 57.28 76.3 57.28 62.28 32.59 58.73 32.59 72.75 57.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-6",
    points: "122.4 23.56 128.44 22.68 130.95 27.76 132.17 15.69 122.4 23.56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-17",
    points: "65.73 117.93 67.74 117.93 68.02 116.64 65.99 116.66 65.73 117.93"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M76.88,144.41a3.5,3.5,0,0,0-.42,1.36l.54-.15Z",
    transform: "translate(-11.57 -26.21)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-18",
    d: "M75.86,149.15v-2.39a1.24,1.24,0,0,1,1.23-1.24h2.43a1.25,1.25,0,0,1,1.24,1.24v2.39a1.25,1.25,0,0,1-1.24,1.24H77.09A1.24,1.24,0,0,1,75.86,149.15Zm1.23-2.8a.41.41,0,0,0-.41.41v2.39a.41.41,0,0,0,.41.42h2.43a.41.41,0,0,0,.41-.42v-2.39a.41.41,0,0,0-.41-.41Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-18",
    x: 61.18,
    y: 121.41,
    width: 11.1,
    height: 7.95,
    rx: 0.82
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-19",
    d: "M72.76,151.5V149a.8.8,0,0,1,.82-.78H83a.81.81,0,0,1,.83.78v2.48Z",
    transform: "translate(-11.57 -26.21)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-20",
    d: "M72.76,151.06v-2.63a.82.82,0,0,1,.82-.82H83a.83.83,0,0,1,.83.82v2.63Z",
    transform: "translate(-11.57 -26.21)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-21",
    d: "M73.63,148.43h9.45a.18.18,0,0,0,.19-.18h0a.18.18,0,0,0-.19-.19H73.63a.18.18,0,0,0-.19.19h0A.18.18,0,0,0,73.63,148.43Z",
    transform: "translate(-11.57 -26.21)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M76.83,145.46v-.88a.91.91,0,0,1,.91-.91h1.13a.91.91,0,0,1,.9.91v1.81a.33.33,0,0,1-.33.33h0a.33.33,0,0,1-.3-.2.35.35,0,0,1-.34.32h-.08a.34.34,0,0,1-.33-.26.33.33,0,0,1-.33.3h-.08a.35.35,0,0,1-.34-.31.33.33,0,0,1-.33.33h-.09a.34.34,0,0,1-.34-.34v-1.09Z",
    transform: "translate(-11.57 -26.21)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M77.2,146.94h0a.38.38,0,0,1-.37-.38v-.94a.38.38,0,0,1,.37-.37h0a.38.38,0,0,1,.38.37v.94A.38.38,0,0,1,77.2,146.94Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-17",
    x: 66.02,
    y: 119,
    width: 0.79,
    height: 1.68,
    rx: 0.38
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-17",
    x: 66.74,
    y: 118.96,
    width: 0.79,
    height: 1.68,
    rx: 0.38
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-17",
    x: 67.49,
    y: 119.13,
    width: 0.71,
    height: 1.43,
    rx: 0.34
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-22",
    points: "69.01 97.23 67.69 108.63 65.32 116.87 68.26 116.94 69.67 109.03 69.01 97.23"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-23",
    d: "M92.86,139.11s3.24,16,5.4,37.73l-2.65-.19-7.89-27.09-1.36,27-2.81,1.19s-3.66-37.35-1.84-39.18Z",
    transform: "translate(-11.57 -26.21)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-22",
    d: "M86.39,175.89s1.33-23.67,1.33-26.33l-1.75-5,.07,1.68-1.13-1.18L86,147.72l.34,28.17Z",
    transform: "translate(-11.57 -26.21)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M88.94,118.75c-.64-.72,2.14-.39,4.93,1.52,0,0,2.57,1.42.62,6.09,0,0-2,6.53-.78,11,0,0,2.24-.1-.23,1.7,0,0,2.82.14-.76,1.31,0,0-7.16,1.66-11.66-.51,0,0-2.21-1.58-.4-1.56,0,0-1.43-1.32.06-1.24a55.46,55.46,0,0,1-.62-11.37s-.35-7,6.26-7Z",
    transform: "translate(-11.57 -26.21)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-22",
    d: "M91.25,118.8s-4,11.83-1.3,22.92c0,0,1.37,4.39,6.37,2.4l-2.06-9.66,1.79-10.89S97.08,119.91,91.25,118.8Z",
    transform: "translate(-11.57 -26.21)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-23",
    d: "M91.27,118.71A46.09,46.09,0,0,0,89,133.57s2.46-11,4.78-14A6.38,6.38,0,0,0,91.27,118.71Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-23",
    x: 90.29,
    y: 137.37,
    width: 3.19,
    height: 0.51,
    transform: "translate(172.19 249.06) rotate(180)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-22",
    d: "M84.62,118.88s-5.36,3.11-3,21.68c0,0,0,3-2.3,3.27,0,0-1.26-20.67,2.44-23.82A7.37,7.37,0,0,1,84.62,118.88Z",
    transform: "translate(-11.57 -26.21)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-23",
    d: "M84.65,118.86s-3.93,2.88-3.59,13.77c0,0-1.39-7.49.74-12.62A6,6,0,0,1,84.65,118.86Z",
    transform: "translate(-11.57 -26.21)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-23",
    d: "M86.81,177.29a4,4,0,0,0-.64-1.56c-.23-.15-.22,0-.23.44,0,.84-1.83,1.06-1.81.23,0-1.26-.34-.78-.34-.78l-.48.27a.17.17,0,0,0-.29.16l-.14.08a.2.2,0,0,0-.21,0,.18.18,0,0,0-.09.22l-.17.1a.16.16,0,0,0-.21-.06.17.17,0,0,0-.09.23l-1,.54s-2.49.1-2.48,1.89c0,0-.25.16,0,.47H87S87.34,177.94,86.81,177.29Z",
    transform: "translate(-11.57 -26.21)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-23",
    d: "M99.39,179s0-.08,0-.12a2.82,2.82,0,0,0-1-2.12.21.21,0,0,0-.1-.26l-.13-.06a.85.85,0,0,0,0-.23,1.39,1.39,0,0,0-2.72,0,.78.78,0,0,0,0,.22l-.15.07a.21.21,0,0,0-.1.28,2.8,2.8,0,0,0-.92,2.1V179a.23.23,0,0,0-.21.23.23.23,0,0,0,.23.23h5a.23.23,0,0,0,.23-.23A.23.23,0,0,0,99.39,179Z",
    transform: "translate(-11.57 -26.21)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M73.73,131.22c-.23,0-1.67-.1-1.67-.1a7.45,7.45,0,0,0-1.54-.44l-3.24,2.25v.57s0,.46.61.48c0,0,0,.58.77.57,0,0,0,.56.79.32,0,0,.26.42.89,0l2.21-1.35,1.87.11Z",
    transform: "translate(-11.57 -26.21)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-24",
    d: "M66.64,131.08l1.1.06a11.35,11.35,0,0,1,1.49-.61,1,1,0,0,1,.47,0l.92.15a.52.52,0,0,1,.42.37l.29.71s0,.21-.32.21a1.55,1.55,0,0,1-1-.56,2.58,2.58,0,0,0-1.24.69,5,5,0,0,0-1.48,1.39l-.25-.11H65.78Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-24",
    x: 71.79,
    y: 133.56,
    width: 0.92,
    height: 0.65,
    rx: 0.27,
    transform: "translate(-77.48 43.97) rotate(-36.89)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-24",
    x: 71.01,
    y: 133.95,
    width: 0.92,
    height: 0.65,
    rx: 0.27,
    transform: "translate(-63.07 18.53) rotate(-25.91)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-24",
    x: 70.25,
    y: 134.43,
    width: 0.92,
    height: 0.65,
    rx: 0.27,
    transform: "translate(-63.35 18.24) rotate(-25.91)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-24",
    x: 69.6,
    y: 134.84,
    width: 0.78,
    height: 0.55,
    rx: 0.23,
    transform: "translate(-38.77 -8.18) rotate(-12.31)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M89.51,114.74l.23,4.27s-2.88,1.71-3.91.11l.31-3.79Z",
    transform: "translate(-11.57 -26.21)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-24",
    d: "M86,116.71l0,.94s3.44-1.24,3.44-2.58l-2.78.76Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-25",
    x: 87.9,
    y: 112.5,
    width: 4.05,
    height: 1.55,
    rx: 0.75,
    transform: "translate(-43.72 164.64) rotate(-83.99)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M85.5,116.84a11.76,11.76,0,0,0,3.18-1s1.07-.36,1.1-2.25c0,0,.23.15.44-.34a.29.29,0,0,1,0-.09l.35-1.16a2.38,2.38,0,0,0-1.75-2.86l-1-.19a1.66,1.66,0,0,0-1-.64,2.18,2.18,0,0,0-2,1s.07-.37-.29-.31c-.8.14-1.11,1.6-1.13,2.86,0,2.1.75,4.72,1.81,4.93Z",
    transform: "translate(-11.57 -26.21)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M90.4,112.94c-.17.57-.55,1-.86.88s-.43-.63-.26-1.2.54-1,.85-.88S90.56,112.36,90.4,112.94Z",
    transform: "translate(-11.57 -26.21)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-25",
    d: "M86.26,110S82,112.88,83,109.66c0,0-4-3.8,5.69-1.87,0,0,4.8-.9,1.9,5.14h-.21s.21-1.19-.41-1.15c0,0-.42,0-.78,1C89.22,112.81,89.6,108.48,86.26,110Z",
    transform: "translate(-11.57 -26.21)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-22",
    d: "M93.06,120.92l-7.8,10.73L73.35,131l0,2.88,14,1.87,8-10S96.93,119.85,93.06,120.92Z",
    transform: "translate(-11.57 -26.21)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-26",
    d: "M54.75,120.66a40.57,40.57,0,0,1,3.75,9.39l8.66.8-.11,2.94-10.14-.11-3.14-2.94Z",
    transform: "translate(-11.57 -26.21)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-27",
    d: "M43.42,139S40.17,155,38,176.72l2.65-.19,7.89-27.09,1.37,27,2.8,1.2s3.67-37.36,1.84-39.19Z",
    transform: "translate(-11.57 -26.21)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-28",
    d: "M49.88,175.77s-1.33-23.67-1.33-26.33l1.75-5-.06,1.68L51.36,145l-1.12,2.62-.35,28.17Z",
    transform: "translate(-11.57 -26.21)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-29",
    d: "M47.33,118.63c.64-.73-2.13-.4-4.93,1.51,0,0-2.57,1.42-.62,6.09,0,0,2,6.53.78,11,0,0-2.24-.1.23,1.7,0,0-2.82.13.76,1.3,0,0,7.16,1.67,11.67-.5,0,0,2.21-1.59.4-1.57,0,0,1.42-1.31-.07-1.23a54.68,54.68,0,0,0,.62-11.37s.36-7-6.26-7Z",
    transform: "translate(-11.57 -26.21)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-26",
    d: "M45,118.68s4,11.82,1.3,22.92c0,0-1.37,4.38-6.37,2.4L42,134.34l-1.78-10.9S39.19,119.78,45,118.68Z",
    transform: "translate(-11.57 -26.21)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-27",
    d: "M45,118.58a46.27,46.27,0,0,1,2.27,14.87s-2.47-11-4.78-14.06A6.31,6.31,0,0,1,45,118.58Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-27",
    x: 31.22,
    y: 111.04,
    width: 3.19,
    height: 0.51
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-26",
    d: "M51.65,118.76s5.36,3.11,3,21.67c0,0-.07,2.95,2.19,3.22,0,0,1.38-20.62-2.32-23.77A7.36,7.36,0,0,0,51.65,118.76Z",
    transform: "translate(-11.57 -26.21)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-27",
    d: "M51.62,118.74s3.93,2.87,3.59,13.76c0,0,1.39-7.48-.73-12.62A6.11,6.11,0,0,0,51.62,118.74Z",
    transform: "translate(-11.57 -26.21)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-28",
    d: "M44.24,150.58a1,1,0,0,0-.23-.22l-.14-.07a.64.64,0,0,0-.31-.07H41.29c-.29,1.81-.83,5-1.27,7.95h3.54a.82.82,0,0,0,.82-.82V151A.83.83,0,0,0,44.24,150.58Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-17",
    x: 25.74,
    y: 118.76,
    width: 2,
    height: 1.28
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M39.75,146.53a3.69,3.69,0,0,1,.42,1.36l-.55-.15Z",
    transform: "translate(-11.57 -26.21)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-18",
    d: "M39.53,152.51H37.1a1.24,1.24,0,0,1-1.23-1.24v-2.39a1.24,1.24,0,0,1,1.23-1.24h2.43a1.24,1.24,0,0,1,1.23,1.24v2.39A1.24,1.24,0,0,1,39.53,152.51Zm-2.43-4a.41.41,0,0,0-.41.41v2.39a.41.41,0,0,0,.41.42h2.43a.41.41,0,0,0,.41-.42v-2.39a.41.41,0,0,0-.41-.41Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-18",
    x: 21.19,
    y: 123.53,
    width: 11.1,
    height: 7.95,
    rx: 0.82
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-19",
    d: "M43.86,153.62v-2.48a.8.8,0,0,0-.82-.78H33.59a.8.8,0,0,0-.82.78v2.48Z",
    transform: "translate(-11.57 -26.21)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-20",
    d: "M43.86,153.18v-2.62a.83.83,0,0,0-.82-.83H33.59a.83.83,0,0,0-.82.83v2.62Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-30",
    x: 26,
    y: 126.37,
    width: 1.47,
    height: 1.47
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-31",
    x: 26.15,
    y: 126.49,
    width: 0.37,
    height: 1.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-21",
    d: "M43,150.56H33.54a.2.2,0,0,1-.19-.19h0a.19.19,0,0,1,.19-.19H43a.18.18,0,0,1,.19.19h0A.19.19,0,0,1,43,150.56Z",
    transform: "translate(-11.57 -26.21)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M39.79,147.58v-.88a.91.91,0,0,0-.9-.91H37.76a.91.91,0,0,0-.91.91v1.82a.33.33,0,0,0,.33.32h0a.32.32,0,0,0,.3-.2.34.34,0,0,0,.34.32H38a.34.34,0,0,0,.33-.26.33.33,0,0,0,.33.3h.08a.35.35,0,0,0,.34-.31.34.34,0,0,0,.34.33h.08a.34.34,0,0,0,.34-.34v-1.09Z",
    transform: "translate(-11.57 -26.21)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-26",
    d: "M40.88,120.84s-1.17,0-3.91,12.95l-.2,11.71H40l.76-11.1,2.46-7.46S44.16,119.61,40.88,120.84Z",
    transform: "translate(-11.57 -26.21)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M86.35,114.44a1.1,1.1,0,0,1-1.15,1.14,1,1,0,0,1-.93-.86Z",
    transform: "translate(-11.57 -26.21)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-27",
    d: "M49.47,177.17a3.9,3.9,0,0,1,.63-1.56c.23-.16.22,0,.23.43,0,.84,1.83,1.07,1.81.23,0-1.26.34-.78.34-.78l.48.27a.19.19,0,0,1,.2,0,.18.18,0,0,1,.09.22l.15.08a.16.16,0,0,1,.2,0,.17.17,0,0,1,.09.22l.17.09a.19.19,0,0,1,.21-.06.17.17,0,0,1,.09.23l1,.55s2.49.09,2.48,1.89c0,0,.25.15,0,.47h-8.3S48.93,177.82,49.47,177.17Z",
    transform: "translate(-11.57 -26.21)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-27",
    d: "M36.88,178.88s0-.08,0-.12a2.82,2.82,0,0,1,1-2.12.22.22,0,0,1,.1-.26l.13,0a1,1,0,0,1,0-.24,1.39,1.39,0,0,1,2.72,0,.91.91,0,0,1,0,.23l.15.06a.21.21,0,0,1,.1.28,2.81,2.81,0,0,1,.93,2.1s0,.08,0,.12a.23.23,0,0,1,.21.23.23.23,0,0,1-.23.24h-5a.23.23,0,0,1-.23-.24A.23.23,0,0,1,36.88,178.88Z",
    transform: "translate(-11.57 -26.21)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-32",
    points: "75.1 93.53 78.41 91.4 79.67 92.6 76.43 95.75 75.1 93.53"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-32",
    d: "M86.67,119.73l-1.53,1.76-.53-2.76L86,118.2A1.92,1.92,0,0,0,86.67,119.73Z",
    transform: "translate(-11.57 -26.21)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M46.82,115l-.22,4.15s2.43,1.29,3.8.1l-.3-3.68Z",
    transform: "translate(-11.57 -26.21)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-24",
    d: "M50.2,116.86l.06.92s-3.35-1.21-3.35-2.52l2.71.74Z",
    transform: "translate(-11.57 -26.21)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-33",
    d: "M46.59,115.48h.06a.73.73,0,0,0,.65-.8L47,112.21a.73.73,0,0,0-.8-.65h-.06a.73.73,0,0,0-.65.79l.26,2.48A.74.74,0,0,0,46.59,115.48Z",
    transform: "translate(-11.57 -26.21)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M50.72,117a11.19,11.19,0,0,1-3.09-.92s-1-.35-1.07-2.19c0,0-.23.14-.43-.33,0,0,0-.06,0-.09l-.34-1.13a2.32,2.32,0,0,1,1.7-2.79l1-.18a1.61,1.61,0,0,1,1-.62,2.13,2.13,0,0,1,2,1s-.08-.37.27-.31c.79.13,1.09,1.56,1.11,2.79,0,2-.73,4.58-1.76,4.79Z",
    transform: "translate(-11.57 -26.21)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-17",
    d: "M46,113.19c.16.56.53.94.83.86s.42-.61.26-1.17-.53-.94-.83-.85S45.8,112.63,46,113.19Z",
    transform: "translate(-11.57 -26.21)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-33",
    d: "M50,110.34s4,1.56,3.14-.34c0,0-1.42-3.54-5.53-1.81,0,0-4.67-.88-1.85,5h.2s-.2-1.15.41-1.11c0,0,.41,0,.75,1C47.1,113.07,46.74,108.85,50,110.34Z",
    transform: "translate(-11.57 -26.21)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M49.9,114.65A1.06,1.06,0,0,0,51,115.76a.94.94,0,0,0,.9-.84Z",
    transform: "translate(-11.57 -26.21)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "landing-svg-4",
    points: "38.02 93.4 34.72 91.27 33.45 92.47 36.69 95.62 38.02 93.4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-4",
    d: "M49.6,119.61l1.53,1.75.53-2.75-1.35-.54A1.9,1.9,0,0,1,49.6,119.61Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 108.92,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 108.92,
    width: 10.77,
    height: 3.71
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 108.93,
    width: 4.6,
    height: 3.69
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,138.08v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 112.65,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 112.65,
    width: 10.77,
    height: 3.71
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 112.66,
    width: 4.6,
    height: 3.69
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,141.81V142a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 116.33,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 116.33,
    width: 10.77,
    height: 3.71
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 116.35,
    width: 4.6,
    height: 3.69
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,145.49v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 120.01,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 120.01,
    width: 10.77,
    height: 3.71
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 120.03,
    width: 4.6,
    height: 3.69
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,149.18v.21a.56.56,0,0,0,.56.56h24.58a.56.56,0,0,0,.55-.56v-.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 123.74,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 123.74,
    width: 10.77,
    height: 3.71
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 123.76,
    width: 4.6,
    height: 3.69
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,152.91v.21a.55.55,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 127.42,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 127.43,
    width: 10.77,
    height: 3.71
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 127.44,
    width: 4.6,
    height: 3.69
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,156.59v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 131.08,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 131.08,
    width: 10.77,
    height: 3.71
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 131.1,
    width: 4.6,
    height: 3.69
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,160.25v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 134.81,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 134.81,
    width: 10.77,
    height: 3.71
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 134.83,
    width: 4.6,
    height: 3.69
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,164v.21a.56.56,0,0,0,.56.56h24.58a.56.56,0,0,0,.55-.56V164Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 138.5,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 138.5,
    width: 10.77,
    height: 3.71
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 138.51,
    width: 4.6,
    height: 3.69
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,167.66v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 142.18,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 142.18,
    width: 10.77,
    height: 3.71
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 142.2,
    width: 4.6,
    height: 3.69
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,171.34v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 145.91,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 145.91,
    width: 10.77,
    height: 3.71
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 145.92,
    width: 4.6,
    height: 3.69
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,175.07v.22a.56.56,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 219.62,
    y: 149.59,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 223.11,
    y: 149.59,
    width: 10.77,
    height: 3.71
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 238.95,
    y: 149.61,
    width: 4.6,
    height: 3.69
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M231.19,178.76V179a.55.55,0,0,0,.56.55h24.58a.55.55,0,0,0,.55-.55v-.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 131.08,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 131.08,
    width: 10.77,
    height: 3.71
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 131.1,
    width: 4.6,
    height: 3.69
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,160.25v.22a.55.55,0,0,0,.55.55h24.59a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 134.81,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 134.81,
    width: 10.77,
    height: 3.71
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 134.83,
    width: 4.6,
    height: 3.69
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,164v.21a.56.56,0,0,0,.55.56h24.59a.56.56,0,0,0,.55-.56V164Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 138.5,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 138.5,
    width: 10.77,
    height: 3.71
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 138.51,
    width: 4.6,
    height: 3.69
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,167.66v.22a.55.55,0,0,0,.55.55h24.59a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 142.18,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 142.18,
    width: 10.77,
    height: 3.71
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 142.2,
    width: 4.6,
    height: 3.69
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,171.34v.22a.55.55,0,0,0,.55.55h24.59a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 145.91,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 145.91,
    width: 10.77,
    height: 3.71
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 145.92,
    width: 4.6,
    height: 3.69
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,175.07v.22a.55.55,0,0,0,.55.55h24.59a.55.55,0,0,0,.55-.55v-.22Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-34",
    x: 248.72,
    y: 149.59,
    width: 25.69,
    height: 3.73,
    rx: 0.55
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 252.21,
    y: 149.59,
    width: 10.77,
    height: 3.71
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-36",
    x: 268.04,
    y: 149.61,
    width: 4.6,
    height: 3.69
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M260.29,178.76V179a.55.55,0,0,0,.55.55h24.59A.55.55,0,0,0,286,179v-.21Z",
    transform: "translate(-11.57 -26.21)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "landing-svg-34",
    cx: 273.14,
    cy: 144.6,
    r: 12.77,
    transform: "translate(-41.61 178.36) rotate(-39.08)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-36",
    d: "M266.17,155.29a12.76,12.76,0,0,0,19.74-10.69,12.8,12.8,0,0,0-.26-2.57C282.56,144.09,271.11,151.91,266.17,155.29Z",
    transform: "translate(-11.57 -26.21)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M273.14,155.42A10.83,10.83,0,1,1,284,144.6,10.84,10.84,0,0,1,273.14,155.42Zm0-20.86a10,10,0,1,0,10,10A10,10,0,0,0,273.14,134.56Z",
    transform: "translate(-11.57 -26.21)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "landing-svg-35",
    d: "M273.17,150.18H273a3.61,3.61,0,0,1-3.21-1.94.6.6,0,0,1,.25-.79.58.58,0,0,1,.78.25A2.44,2.44,0,0,0,273,149a2.87,2.87,0,0,0,1.85-.56,1.79,1.79,0,0,0,.67-1.71,1.76,1.76,0,0,0-1.18-1.2,6,6,0,0,0-1.16-.25c-.3-.05-.61-.09-.92-.17a3.8,3.8,0,0,1-2.49-1.63,3.1,3.1,0,0,1,.63-3.43,3.76,3.76,0,0,1,3.43-1,3.18,3.18,0,0,1,2.45,2,.58.58,0,0,1-.33.75.58.58,0,0,1-.75-.34,2.08,2.08,0,0,0-1.6-1.25,2.62,2.62,0,0,0-2.36.64,2,2,0,0,0-.43,2.12,2.71,2.71,0,0,0,1.72,1,7.4,7.4,0,0,0,.82.15,7.76,7.76,0,0,1,1.38.3,2.91,2.91,0,0,1,1.93,2.05,3,3,0,0,1-1.12,2.89A4,4,0,0,1,273.17,150.18Z",
    transform: "translate(-11.57 -26.21)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "landing-svg-35",
    x: 261.17,
    y: 111.2,
    width: 0.79,
    height: 14.39,
    rx: 0.34
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage);
export default __webpack_public_path__ + "static/media/landing-image.567ffa6c.svg";
export { ForwardRef as ReactComponent };